import config from "@/data/config.json";
import content from "@/data/content.json";
import _package from "@/../package.json";

import { useSettingsStore } from "@/dev/store/useSettingsStore.js";

function getSetting(key) {
  const settingsStore = useSettingsStore();

  let value = null;

  // check config,
  // then check config (nested),
  // then check package
  // then check ENV

  if (config[key]) {
    value = config[key]; //config
  } else if (key.includes(".")) {
    // if key has a period, split it and check nested keys
    const keys = key.split(".");
    value = keys.reduce((obj, k) => (obj && obj[k] ? obj[k] : null), config);
  } else if (_package[key]) {
    value = _package[key]; // package
  } else if (import.meta.env[key]) {
    value = import.meta.env[key]; // env
  } else if (import.meta.env[`VITE_${key}`]) {
    value = import.meta.env[`VITE_${key}`]; // env
  } else if (content[key]) {
    value = content[key]; // content
  }

  if (value === null) {
    console.warn(`[Setting] key "${key}" not found.`);
  }

  if (!value) {
    console.warn(`[Setting] key "${key}" not found.`);
    settingsStore.addKeyMissing(key);
  } else {
    settingsStore.addKeyFound(key, value);
  }

  return value;
}

export function $s(key) {
  return getSetting(key);
}
